module.exports = __webpack_public_path__ + "static/1010069056.705ac4f1.jpg";